import React, { ReactElement } from 'react';
import { Typography } from '@material-ui/core';

interface KlarnaStepsProps {
  maxWidth?: number;
  ctaText?: string;
}

const KlarnaSteps = ({
  maxWidth = 420,
  ctaText = 'Continue',
}: KlarnaStepsProps): ReactElement => {
  const steps = [
    'Review your plans by clicking "See Plans" below',
    `Click ${ctaText} on this screen`,
    'Select your plan at checkout',
  ];
  return (
    <div
      style={{
        background: '#FFF4FB',
        border: '1px solid #F3D3E7',
        borderRadius: 12,
        padding: '14px 16px',
        marginTop: 16,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        maxWidth,
        boxSizing: 'border-box',
      }}
    >
      <Typography
        style={{
          fontFamily: 'Inter',
          fontSize: 15,
          fontWeight: 700,
          color: '#111',
          marginBottom: 10,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span role="img" aria-label="card" style={{ fontSize: 18 }}>
          💳
        </span>
        Want to pay in installments with Klarna?
      </Typography>

      <ol
        style={{
          margin: 0,
          padding: 0,
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {steps.map((label, i) => (
          <li
            key={label}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
            }}
          >
            <span
              style={{
                flexShrink: 0,
                width: 22,
                height: 22,
                borderRadius: '50%',
                background: '#FFA8CD',
                color: '#111',
                fontFamily: 'Inter',
                fontSize: 12,
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: 1,
              }}
            >
              {i + 1}
            </span>
            <Typography
              style={{
                fontFamily: 'Inter',
                fontSize: 13.5,
                color: '#1f2422',
                lineHeight: 1.4,
              }}
            >
              {label}
            </Typography>
          </li>
        ))}
      </ol>
    </div>
  );
};

KlarnaSteps.defaultProps = {
  maxWidth: 420,
  ctaText: 'Continue',
};

export default KlarnaSteps;
